import { Component, Input, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Timezome } from 'src/app/interface/buildings.interface';
import { DoorType } from 'src/app/interface/door.interface';
import { AccessEntryStatus } from 'src/app/interface/frequentAccess.inteface';
import { DataService } from 'src/app/services/data.service';
import * as moment from 'moment-timezone';
import { Languaje } from 'src/app/shared/constants/constants';

@Component({
  selector: 'access-timeline',
  templateUrl: './access-timeline.component.html',
  styleUrls: ['./access-timeline.component.scss']
})
export class AccessTimelineComponent implements OnInit {
  @Input() accessEntries: any[] = [];

  doorIcon = [
    {
      type: DoorType.entrance,
      icon: "entry"
    },
    {
      type: DoorType.exit,
      icon: "exit"
    }
  ];
  timezone = this.dataService.getBuildingTimeZone() ?? Timezome.panama;
  languageLocale = localStorage.getItem('munily-language') ?? Languaje.es;

  constructor(
    private domSanitizer: DomSanitizer,
    private matIconRegistry: MatIconRegistry,
    private dataService: DataService
  ) {
    this.addSvgIcon('entry', 'assets/images/icons/icon-entry.svg');
    this.addSvgIcon('exit', 'assets/images/icons/icon-exit.svg');
  }

  ngOnInit(): void {
    this.changeStatusLabel();
  }

  getIconDooType(type: DoorType) {
    const icon = this.doorIcon.find(door => door.type === type);
    return icon.icon
  }

  addSvgIcon(name: string, path: string) {
    this.matIconRegistry.addSvgIcon(name, this.domSanitizer.bypassSecurityTrustResourceUrl(path));
  }

  changeStatusLabel() {
    for (let i = 0; i < this.accessEntries.length; i++) {
      const entry = this.accessEntries[i];
      const nextEntry = this.accessEntries[i + 1] ?? null;

      switch (entry.status) {
        case AccessEntryStatus.completed:
          entry.status = AccessEntryStatus.left;
          break;
        case AccessEntryStatus.active:
          entry.status = AccessEntryStatus.entered;
          break;
        case AccessEntryStatus.timeExceeded:
          if (nextEntry && nextEntry.date) {
            const nextMark = new Date(nextEntry.date);
            entry.timeEx = this.calculateExceededTime(nextMark, entry.date);
          } else {
            const currentTime = new Date();
            entry.timeEx = this.calculateExceededTime(currentTime, entry.date);
          }
          break;
      }
    }
  }

  calculateExceededTime(expirationDate: string | Date, until: string | Date): { hours: string, minutes: string } {
    if (!expirationDate || !until) {
      return { hours: '00', minutes: '00' };
    }

    const expiration = moment.tz(expirationDate, this.timezone);
    const untilMoment = moment.tz(until, this.timezone);

    if (untilMoment.isBefore(expiration)) {
      return { hours: '00', minutes: '00' };
    }

    const duration = moment.duration(untilMoment.diff(expiration));
    const totalMinutes = duration.asMinutes();
    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.floor(totalMinutes % 60);

    return {
      hours: hours < 10 ? '0' + hours : String(hours),
      minutes: minutes < 10 ? '0' + minutes : String(minutes)
    };
  }

  getFormattedDate(date: string): string {
    return moment.tz(date, this.timezone).locale(this.languageLocale).format('DD MMM YYYY - HH:mm a');
  }
}
